import firebase, { database } from '../firebase'
import * as constants from '../Constatnts'
import axios from 'axios';


export function getTransactions(
  from = 0,
  size = 100,
  storeID,
  fromDate,
  toDate,
  paymentType = "",
  toAccount = "",
  fromAccount = ""
) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      let apiUrl = "/transaction/accounmangment";

      const params = {
        from: Number(from),
        size: Number(size),
        fromDate,
        storeID,
        toDate,
        paymentType,
        toAccount,
        fromAccount
      };

      let queryParams = [];

      Object.keys(params).forEach((key) => {
        if (
          params &&
          Object.prototype.hasOwnProperty.call(params, key) &&
          params[key] !== undefined &&
          params[key] !== null &&
          params[key] !== ""
        ) {
          queryParams.push(
            key + "=" + encodeURIComponent(params[key])
          );
        }
      });

      // build final url
      if (queryParams.length > 0) {
        apiUrl = apiUrl + "?" + queryParams.join("&");
      }

      const response = await axios.get(
        constants.API_URL + apiUrl,
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      );

      if (
        response &&
        Object.prototype.hasOwnProperty.call(response, "data")
      ) {
        return response.data;
      }

      return null;
    } catch (error) {
      console.error(
        "Error fetching transaction data:",
        error
      );

      if (
        error &&
        Object.prototype.hasOwnProperty.call(error, "response") &&
        error.response &&
        Object.prototype.hasOwnProperty.call(error.response, "data")
      ) {
        throw error.response.data;
      }

      throw error;
    }
  };
}


export function saveTransaction(transaction, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key !== "") {
        // Update existing account
        response = await axios.put(
          `${constants.API_URL}/transaction/accounmangment/${key}`,
          transaction,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new account
        response = await axios.post(
          `${constants.API_URL}/transaction/accounmangment`,
          transaction,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
          return response.data.data.key;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}



export function cancelTransaction(cancellationReason, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.put(
        `${constants.API_URL}/transaction/accounmangment/cancel/${key}`,
        {
          cancellationReason: cancellationReason,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code === "0") {
        return true;
      } else {
        alert(response.data.message || "Failed to cancel transaction");
        return false;
      }

    } catch (error) {
      console.error("Cancel Transaction Error:", error);
      alert("Failed to cancel transaction");
      return false;
    }
  };
}
// export function cancelTransaction(cancellationReason, key) {
//     return (dispatch, getState) => {
//         return database.collection("AccountManagement").doc(key).update({
//             ActionOn: firebase.firestore.FieldValue.serverTimestamp(),
//             ActionBy: getState().user.user.Name,
//             ActionByUID: getState().user.user.UID,
//             ActionByEmailID: getState().user.user.EmailID,
//             Action: "CANCEL",
//             CancellationReason: cancellationReason
//         }).then(() => { return true })
//     }
// }


export function getCashDebitEntriesFromAccountManagement(cashRegisterID, fromDate) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
    const response = await axios.get(
        `${constants.API_URL}/setup/stores/${getState().user.store.key}/cashregisters/${cashRegisterID}/cashdebitentries?fromDate=${fromDate}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.amount || 0;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getCashCreditEntriesFromAccountManagement(cashRegisterID, fromDate) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
    const response = await axios.get(
        `${constants.API_URL}/setup/stores/${getState().user.store.key}/cashregisters/${cashRegisterID}/cashcreditentries?fromDate=${fromDate}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.amount || 0;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}
